import { Autocomplete, TextField, Typography } from '@mui/material';
import customAxios from '../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalVariables } from '../../globalVar';
import { getToast } from '../../utils/toastConfig';

function ModalAsignTech(props) {
  var asignVisitClientName = localStorage.getItem('visitClientNameForAsign');
  var asignVisitSiteName = localStorage.getItem('visitSiteNameForAsign');
  var asignVisitTypeName = localStorage.getItem('visitTypeNameForAsign');

  const [techId, setTechId] = useState(null);

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Técnico asignado exitosamente al servicio.',
    });
    setTimeout(() => {
      window.location.reload();
    }, 3600);
  }

  function asignTech() {
    var visit_id = localStorage.getItem('visitIdToAsignTech');
    customAxios
      .patch(
        `${GlobalVariables.getURL()}assignTech/${visit_id}`,
        {
          // url to POST
          technical_id: techId.id,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then(
        (response) => {
          hide();
        },
        (error) => {
          console.log(error);
          getToast({
            status: 'error',
            title: 'Error al asignar técnico. Vuelve a intentarlo.',
          });
        }
      );
  }

  const [techs, setTechs] = useState([]);

  useEffect(() => {
    customAxios
      .get(`${GlobalVariables.getURL()}autofillTechs`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setTechs(response.data);
      })

      .catch((error) => console.log(error));
  }, []);

  return (
    <Modal
      {...props}
      size="m"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
      className="mui-modals-updated"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Asignar técnico
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="asign-tech-form">
          <div className="asign-tech-data">
            <div className="asign-tech-line">
              <Typography>
                <strong>Plaza:</strong>
              </Typography>
              <Typography>{asignVisitClientName}</Typography>
            </div>
            <div className="asign-tech-line">
              <Typography>
                <strong>Sucursal:</strong>
              </Typography>
              <Typography>{asignVisitSiteName}</Typography>
            </div>
            <div className="asign-tech-line">
              <Typography>
                <strong>Tipo de servicio:</strong>
              </Typography>
              <Typography>{asignVisitTypeName}</Typography>
            </div>
          </div>

          <br />

          <Autocomplete
            disablePortal
            options={techs}
            sx={{ width: '100%' }}
            getOptionLabel={(techs) => techs.name + ' ' + techs.last_name}
            getOptionSelected={(techs, value) => techs.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Seleccionar técnico..." />
            )}
            onChange={(event, newValue) => {
              setTechId(newValue);
            }}
          />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          form="asign-tech-form"
          className="save-modal-button"
          onClick={() => {
            asignTech();
          }}
        >
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAsignTech;
